export type MessageSegment =
  | { kind: "speech" | "action" | "thought"; text: string };

export function parseMessageMarkup(content: string): MessageSegment[] {
  const segments: MessageSegment[] = [];
  const pattern = /\[thought\]([\s\S]*?)\[\/thought\]|\*([^*\n]+)\*/gi;
  let cursor = 0;

  for (const match of content.matchAll(pattern)) {
    const index = match.index ?? 0;
    if (index > cursor) segments.push({ kind: "speech", text: content.slice(cursor, index) });
    if (match[1] !== undefined) segments.push({ kind: "thought", text: match[1] });
    else segments.push({ kind: "action", text: match[2] });
    cursor = index + match[0].length;
  }

  if (cursor < content.length) segments.push({ kind: "speech", text: content.slice(cursor) });
  return segments.length ? segments : [{ kind: "speech", text: content }];
}
